import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { PlatformTemplate } from 'templates';
import { Tables } from 'pages';

export default function Routes() {
  return (
    <PlatformTemplate>
      <Switch>
        <Route exact path="/garcon/RequestsTablesAdd">
          <Tables />
        </Route>
      </Switch>
    </PlatformTemplate>
  );
}
